module.exports = __webpack_public_path__ + "img/ic-home.c6a98649.svg";